import {useStepCheck} from "../stepcheck/useStepCheck";
import {MismatchedStepError} from "../../domain/exception/MismatchedStepError";

export const useSubmit = (verificationId: string | undefined) => {
    const { redirectToStep } = useStepCheck(verificationId)

    const submitImage = async (image: Blob, onSubmit: (image: Blob) => void, onFailure?: () => void) => {
        try {
            await onSubmit(image)
        } catch (err: any) {
            if (err instanceof MismatchedStepError) {
                redirectToStep(err.correctStep)
            } else {
                console.error(err)
            }
            if (onFailure) {
                onFailure()
            }
        }
    }

    const submit = async (onSubmit: () => void, onFailure?: () => void) => {
        try {
            await onSubmit()
        } catch (err: any) {
            if (err instanceof MismatchedStepError) {
                redirectToStep(err.correctStep)
            } else {
                console.error(err)
            }
            if (onFailure) {
                onFailure()
            }
        }
    }

    return {
        submit,
        submitImage,
    }
}